import React from "react";
import { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';

import Loader from './common/Loader';

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';
import { getFileNameWithoutExtension } from './AssetCreateEdit';


export default function AssetMassLoad(){

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  const navigate = useNavigate();

  const [formError, setFormError] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState([]);
  const [uploadCompleted, setUploadCompleted] = useState(false);
  
  // Вычисляем доступные годы
  const currentYear = new Date().getFullYear();
  const availableYears = [currentYear - 1, currentYear, currentYear + 1];
  
  const [massData, setMassData] = useState({
    files: [],
    year: currentYear,
    category: '',
    type: 'FILE'
  });


  // Загрузка категорий
  React.useEffect(() => {
    axios_api.get(api_url + '/asset_categories/', {
      headers: {"Authorization": token},
    })
    .then(
      (result) => {
        setCategories(result.data);
        setCategoriesLoading(false);
      },
      (error) => {
        console.log('Ошибка загрузки категорий:', error);
        setCategories([]);
        setCategoriesLoading(false);
      }
    );
  }, [api_url, token]);


  const handleChange = (event) => {
    const name = event.target.id;
    let value = event.target.value;
    
    const massDataNext = structuredClone(massData);
    massDataNext[name] = value;
    setMassData(massDataNext);
    setFormError(false);
  };

  const handleFilesChange = (event) => {
    const files = Array.from(event.target.files);
    const massDataNext = structuredClone(massData);
    massDataNext.files = files;
    setMassData(massDataNext);
    setFormError(false);
    setUploadCompleted(false);
    // Инициализируем прогресс для каждого файла
    setUploadProgress(files.map(file => ({
      name: file.name,
      status: 'pending', // pending, uploading, success, error
      message: ''
    })));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormError(false);

    // Валидация
    if (!massData.files || massData.files.length === 0) {
      setFormError('Необходимо выбрать файлы для загрузки');
      return;
    }

    if (!massData.year) {
      setFormError('Необходимо выбрать год');
      return;
    }

    setUploading(true);

    // Загружаем файлы последовательно
    for (let i = 0; i < massData.files.length; i++) {
      const file = massData.files[i];
      
      // Обновляем статус файла на "загружается"
      setUploadProgress(prev => prev.map((item, index) => 
        index === i ? { ...item, status: 'uploading' } : item
      ));

      try {
        // Подготовка данных для отправки
        const formData = new FormData();
        formData.append('name', getFileNameWithoutExtension(file.name));
        formData.append('type', 'FILE');
        formData.append('year', massData.year);
        
        if (massData.category) {
          formData.append('category', massData.category);
        }
        
        formData.append('file', file);

        // Создание asset
        await axios_api.post(api_url + `/manage_asset/`, formData, {
          headers: {
            "Authorization": token,
            "Content-Type": "multipart/form-data",
          }
        });

        // Успешная загрузка
        setUploadProgress(prev => prev.map((item, index) => 
          index === i ? { ...item, status: 'success', message: 'Загружено успешно' } : item
        ));

      } catch (error) {
        // Ошибка загрузки
        const errorMessage = error.request?.status === 413 ? 
          'Размер файла превышает разрешенный' : 
          error.response?.data?.file?.[0] || 
          error.response?.data || 
          'Ошибка загрузки';
        
        setUploadProgress(prev => prev.map((item, index) => 
          index === i ? { 
            ...item, 
            status: 'error', 
            message: typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage)
          } : item
        ));
        
        console.log(`Ошибка загрузки файла ${file.name}:`, error);
      }
    }

    setUploading(false);
    setUploadCompleted(true);
  };

  const handleCancel = () => {
    navigate("/asset_list");
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return '';
      case 'uploading':
        return '⬆️';
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      default:
        return '';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'uploading':
        return 'text-primary';
      case 'success':
        return 'text-success';
      case 'error':
        return 'text-danger';
      default:
        return 'text-secondary';
    }
  };

  return (
    <>
      <div className="row">
        <h3 className="m-3">Массовая загрузка материалов</h3>
      </div>
      <div className='row'>
        <div className="col-8 ms-3 lk-form">
          <form onSubmit={handleSubmit}>

            <div className="input-group my-3">
              <label className="mt-3">
                <p>год</p>
                <select 
                  id="year" 
                  className="lk-select form-select" 
                  value={massData.year} 
                  onChange={handleChange}
                  disabled={uploading}
                  style={{width: '200px'}}
                >
                  {availableYears.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </label>
            </div>

            <div className="input-group my-3">
              <label className="mt-3">
                <p>категория</p>
                {categoriesLoading ? (
                  <select className="lk-select form-select" disabled style={{width: '200px'}}>
                    <option>Загрузка...</option>
                  </select>
                ) : (
                  <select 
                    id="category" 
                    className="lk-select form-select" 
                    value={massData.category} 
                    onChange={handleChange}
                    disabled={uploading}
                    style={{width: '200px'}}
                  >
                    <option value="">- выбрать -</option>
                    {categories.map(category => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                )}
              </label>
            </div>

            <div className="input-group my-3">
              <label className="mt-3">
                <p>тип</p>
                <select 
                  id="type" 
                  className="lk-select form-select" 
                  value={massData.type} 
                  disabled
                  style={{width: '200px'}}
                >
                  <option value="FILE">файл</option>
                </select>
              </label>
            </div>

            <div className="input-group my-3">
              <label className="mt-3">
                <p>файлы</p>
                <input 
                  id="files" 
                  type="file" 
                  className="form-control my-3" 
                  onChange={handleFilesChange}
                  multiple
                  disabled={uploading}
                />
              </label>
              {massData.files.length > 0 && (
                <p className="text-muted">Выбрано файлов: {massData.files.length}</p>
              )}
            </div>

            {formError && (
              <p className="text-danger">{formError}</p>
            )}

            {uploadProgress.length > 0 && (
              <div className="my-4">
                <h5>Прогресс загрузки:</h5>
                <div className="list-group">
                  {uploadProgress.map((item, index) => (
                    <div 
                      key={index} 
                      className={`list-group-item d-flex justify-content-between align-items-start ${getStatusColor(item.status)}`}
                    >
                      <div className="flex-grow-1">
                        <span className="me-2">{getStatusIcon(item.status)}</span>
                        <strong>{item.name}</strong>
                        {item.message && (
                          <div className="small mt-1">{item.message}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            <div className="d-flex gap-2">
              <button 
                type="submit" 
                className="btn lk-button my-3"
                disabled={uploading || massData.files.length === 0 || uploadCompleted}
              >
                {uploading ? 'Загрузка...' : 'Загрузить'}
              </button>
              
              <button 
                type="button" 
                className="btn btn-secondary my-3 ms-4" 
                onClick={handleCancel}
                disabled={uploading}
              >
                К списку материалов
              </button>
            </div>
          </form>
        </div>               
      </div>
    </>
  )
}
